import React from "react";
import { EventLayer } from "./event-layer";
import { useTranslationsById } from "../../../../hooks/use-translations-by-id";

/**
 * Vista secundaria que lista horarios equivalentes por zona horaria.
 */
export const TimeZones = ({ list, visible, setVisible, lang }) => {
	const texts = useTranslationsById({ mainSectionName: "reading_resources", language: lang });

	return (
		<EventLayer
			title={texts.getText({
				id: "makemake_en_vivo.evento.boton.horarios",
				defaultText: "Schedules",
			})}
			visible={visible}
			setVisible={setVisible}
		>
			<ul className="d-flex w-100 flex-column flex-grow-1">
				{list?.map((item, i) => {
					return (
						<li
							key={i}
							className="onbackground-primary--color font-weight-bold secondary-font"
						>
							{item}
						</li>
					);
				})}
			</ul>
		</EventLayer>
	);
};
